import type { BadgeKind } from '@/components/StatusBadge';

/**
 * O que a lista e a página de detalhe compartilham.
 * Fora dos arquivos de componente por causa do fast refresh do Vite.
 */
export const SITUATION_TONE: Record<string, BadgeKind> = {
  AGUARDANDO_CONFERENCIA: 'info',
  AGUARDANDO_LANCAMENTO: 'warn',
  LANCADA: 'ok',
  COM_DIVERGENCIA: 'bad',
  CANCELADA: 'bad',
  REJEITADA: 'bad',
  IGNORADA: 'mute',
};

export const FISCAL_TONE: Record<string, BadgeKind> = {
  AUTORIZADA: 'ok',
  CANCELADA: 'bad',
  DENEGADA: 'bad',
  REJEITADA: 'bad',
  DESCONHECIDA: 'mute',
  NAO_APLICA: 'mute',
};

export const CHECK_TONE: Record<string, BadgeKind> = {
  PENDENTE: 'warn',
  EM_CONFERENCIA: 'info',
  VALIDADO: 'ok',
  COM_DIVERGENCIA: 'bad',
  DISPENSADA: 'mute',
};

export const TARGET_TONE: Record<string, BadgeKind> = {
  NAO_APLICA: 'mute',
  PENDENTE: 'warn',
  LANCADO: 'ok',
  COBERTO: 'info',
  BLOQUEADO: 'bad',
};

export const DIVERGENCE_TONE: Record<string, BadgeKind> = {
  ABERTA: 'bad',
  EM_ANALISE: 'warn',
  RESOLVIDA: 'ok',
  ACEITA: 'ok',
  RECUSADA: 'mute',
};

/** Chave de acesso legível: 11 grupos de 4, como no DANFE. */
export function formatAccessKey(key: string | null): string {
  if (!key) return '—';
  return key.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
}

/** Caminho da página de detalhe — é para lá que a linha da tabela leva. */
export const documentoPath = (id: string): string => `/compras/documentos/${id}`;
/** Rota da lista, como `string`: as rotas de módulo não entram no mapa tipado. */
export const LISTA_DOCUMENTOS: string = '/compras/documentos';
